export enum Measurement {
  Temperature = 'temp',
  Humidity = 'humid',
  CO2 = 'co2',
  Chemicals = 'voc',
  PM25 = 'pm25',
}
export enum MeasurementIndex {
  Temperature = 'temp.index',
  Humidity = 'humid.index',
  CO2 = 'co2.index',
  Chemicals = 'voc.index',
  PM25 = 'pm25.index',
}



// WEBPACK FOOTER //
// ./src/app/dashboard/enums/measurement.enum.ts